import listingLosCabos from '../customizations/listingLosCabos.json';
import listingCDMX from '../customizations/listingCDMX.json';


export const CONFIG_TYPES = {
  LISTING_LOS_CABOS: 'listing-los-cabos',
  LISTING_CDMX: 'listing-cdmx'
};

const getCurrentConfig = () => {
  const configType = process.env.REACT_APP_CONFIG_TYPE || CONFIG_TYPES.LISTING_LOS_CABOS;
  
  switch (configType) {
    case CONFIG_TYPES.LISTING_CDMX:
      return listingCDMX;
    case CONFIG_TYPES.LISTING_LOS_CABOS:
    default:
      return listingLosCabos;
  }
};

export const getMapConfig = () => {
  try {
    const config = getCurrentConfig();
    return config.mapConfig;
  } catch (error) {
    console.error('Error getting map config:', error);
    return { center: { lat: 0, lng: 0 }, zoom: 13 };
  }
};

export const getText = (key) => {
  try {
    const config = getCurrentConfig();
    return config.text[key] || key;
  } catch (error) {
    console.error('Error getting text for key:', key, error);
    return key;
  }
};


export const getImage = (key) => {
  try {
    const config = getCurrentConfig();
    return config.images[key] || key;
  } catch (error) {
    console.error('Error getting image for key:', key, error);
    return key;
  }
};


export const getSubscriptions = () => {
  try {
    const config = getCurrentConfig();
    return config.subscriptions || {};
  } catch (error) {
    console.error('Error getting subscriptions:', error);
    return {};
  }
};
